<!-- =========================================================================================
	File Name: ECommerceWishList.vue
	Description: eCommerce Wish List Page
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="match-list">
      <div class="items-grid-view vx-row match-height" v-if="matchList.length" appear>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full" v-for="item in matchList" :key="item.objectID" :title="item.title">
              <item-grid-view :item="item">
                  <!-- SLOT: ACTION BUTTONS -->
                  <template slot="action-buttons">
                      <div class="flex flex-wrap" v-if="item.matchStatus == 3">
                          <div
                              class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer"
                              @click="goToMatchDetail(item)">
                              <feather-icon icon="ArrowRightCircleIcon" svgClasses="h-4 w-4" />
                              <span class="ml-2">查看比赛</span>
                          </div>
                          <div
                              class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                              @click="goToMyMatchDetail(item)">
                              <feather-icon icon="BoxIcon" svgClasses="h-4 w-4" />

                              <span class="ml-2">作品列表</span>
                          </div>
                      </div>
                      <div class="flex flex-wrap" v-else-if="item.matchStatus == 2">
                          <div
                              class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer"
                              @click="goToMatchDetail(item)">
                              <feather-icon icon="ArrowRightCircleIcon" svgClasses="h-4 w-4" />

                              <span class="ml-2">查看比赛</span>
                          </div>

                          <vx-tooltip 
                            class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer" 
                            text="赛程正在报名中，还没开始提交作品喔！" 
                            position="bottom">
                                <feather-icon icon="LoaderIcon" svgClasses="h-4 w-4" />
                                <span class="ml-2">报名中</span>
                          </vx-tooltip>
                      </div>
                      <div class="flex flex-wrap" v-else-if="item.matchStatus == 4">
                          
                          <div
                              class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer"
                              >
                              <feather-icon icon="AwardIcon" svgClasses="h-4 w-4" />
                              <span class="ml-2">比赛结束</span>
                          </div>
                      </div>
                  </template>
              </item-grid-view>
          </div>
      </div>
      <!-- IF NO ITEMS IN CART -->
      <vx-card title="还未成为赛事的评委" v-else>
          <vs-button>知道了</vs-button>
      </vx-card>
  </div>
</template>

<script>
import { list } from "@/api/match";
import { getToken } from "@/utils/tools";
import config from '@/config'
const ItemGridView = () => import("./components/ItemGridView.vue");

export default {
  data() {
    return {
      matchList: [],
    };
  },
  components: {
    ItemGridView,
  },
  computed: {
    listitems() {
      return this.matchList;
    },
  },
  methods: {
    getList() {
      let that = this
      list({
        access_token: getToken(),
      }).then((res) => {
        const data = res.data;
        that.matchList = data.list.sort(function(a, b){
            if (a.matchStatus === b.matchStatus) {
              return a.status - b.status
            } else {
              return a.matchStatus - b.matchStatus
            }
          })
      });
    },
    goToMatchDetail(item) {
      window.open(item.url);
    },
    goToMyMatchDetail(item) {
      this.$router.push({path: '/match/detail', query: {matchId: item.matchId, scheduleId: item.scheduleId}});
    },
  },
  created() {
    this.getList()
  },
};
</script>

<style lang="scss" scoped>
#match-list {
  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
    min-width: 50%;
  }

  .item-view-secondary-action-btn {
    min-width: 50%;
  }
}
</style>
